var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UserApi } from '@common/api/user';
import { createPath } from '@common/application/utils/create-path';
import { ROUTE_MAP } from '@common/constants/route-map';
import Router from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button } from './button';
import { Modal } from './modal';
export default function MemberExpirationModal({ memberExpirationFlag }) {
    const { t } = useTranslation();
    return (_jsxs(Modal, Object.assign({ open: memberExpirationFlag, destroyFooter: true, destroyHeader: true }, { children: [_jsx("div", Object.assign({ className: "bg-[#FAF4F0] text-[#6A2416] text-lg pc:text-[24px] h-16.5 flex items-center px-6" }, { children: t('validateModal.title') })), _jsx("div", Object.assign({ className: "pt-6 px-6" }, { children: t('validateModal.content') })), _jsxs("div", Object.assign({ className: "flex h-45 pc:h-57 flex-col justify-center items-center" }, { children: [_jsx(Button, Object.assign({ className: "w-50 h-11 pc:w-70 pc:h-13.5", onClick: () => {
                            Router.push(`${createPath(ROUTE_MAP.APPLY_MEMBER)}?type=confirm`);
                        } }, { children: t('validateModal.confirm') })), _jsx(Button, Object.assign({ onClick: () => __awaiter(this, void 0, void 0, function* () {
                            try {
                                yield UserApi.deleteExpireMemberLevel();
                                window.location.reload();
                            }
                            catch (error) {
                                console.log(error);
                            }
                        }), className: "w-50 h-11 mt-5 pc:w-70 pc:h-13.5 pc:mt-6", dark: false, color: "black-2" }, { children: t('validateModal.delete') }))] }))] })));
}
